// @ts-nocheck
import type { ComponentProps } from "react"

import {
  Dropdown as KitDropdown,
  type DropdownMenuProps,
} from "@/components/ui-kit/untitled/base/dropdown/dropdown"

import { cx } from "@uui/utils/cx"

/*
 * A popover floats over the page, so it is paper that lifts: stone.50, a
 * hairline, shadow.lift. The stone.200 well it used to be read
 * as a rose system colour beside the ink. Rows are 30px with 12.5px labels at
 * 500 and 14px icons in ink.quiet; the hovered row is a stone.100 wash.
 */
const Popover = ({
  className,
  ...props
}: ComponentProps<typeof KitDropdown.Popover>) => (
  <KitDropdown.Popover
    className={cx(
      "bg-primary ring-secondary shadow-lift",
      typeof className === "string" ? className : undefined,
    )}
    {...props}
  />
)

const Item = ({
  className,
  ...props
}: ComponentProps<typeof KitDropdown.Item>) => (
  <KitDropdown.Item
    className={cx(
      "[&>div]:hover:bg-secondary_subtle [&_svg]:text-quaternary [&_span]:text-[12.5px] [&_span]:font-medium [&_svg]:size-3.5 [&_svg]:stroke-2 [&>div]:h-[30px] [&>div]:px-2 [&>div]:py-0",
      typeof className === "string" ? className : undefined,
    )}
    {...props}
  />
)

export const Dropdown: typeof KitDropdown = { ...KitDropdown, Popover, Item }
export type { DropdownMenuProps }
